import styled, { device, css, themeGet } from "@styled";

export const SectionWrap = styled.section`
    background-color:#f8f8f8;
    ${({ $space }) =>
        $space === 1 &&
        css`
            padding-block-start: 40px;
            padding-block-end: 40px;
            ${device.medium} {
                padding-block-start: 60px;
                padding-block-end: 60px;
            }
            ${device.large} {
                padding-block-start: 80px;
                padding-block-end: 80px;
            }
        `}
    ${({ $space }) =>
        $space === 2 &&
        css`
            padding-block-end: 40px;
            ${device.medium} {
                padding-block-end: 55px;
            }
            ${device.large} {
                padding-block-end: 65px;
            }
        `}
`;

export const BoxWrap = styled.div`
    padding:20px;
    &:hover {
        transform: translateY(-5px);
        background: #fff;
        box-shadow: ${themeGet("shadows.default")};
        border-radius: ${themeGet("radii.md")};
        transition: all 0.3s ease-in-out;
    }
`
export const TitleWrap = styled.h5`
    text-align:center;
    font-size:34px;
    
`;

export const SubTitleWrap = styled.p`
    text-align:center;
    font-size:24px;
    padding-block-end:20px;
    span{
        color:#086AD8;
    }
`;


